<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [information]="(circumference | number:'1.0-0') + '%'" [limitedTo]="themeOptions.limitedTo(optionType)">
  <div app-theme-option-content>
    <app-show-details-option [showDetails]="showDetails" (sendShowDetails)="receiveShowDetails($event)">
      <div app-show-details-option-content>
        <app-slider [color]="color" [value]="circumference" (sendValue)="receiveValue($event)"></app-slider>
      </div>
    </app-show-details-option>
  </div>
</app-theme-option>

<div *ngIf="showDetails">
  <app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categoriesAndLabel" [label]="type | chart" [dark]="4" [information]="(circumferences[type] | number:'1.0-0') + '%'" *ngFor="let type of themeOptions.limitedTo(optionType)">
    <div app-theme-option-content>
      <app-slider [value]="circumferences[type]" (sendValue)="receiveValue($event, type)" [color]="color"></app-slider>
    </div>
  </app-theme-option>
</div>